import { Modal, Text } from '@ui/themed';
import { t } from 'i18next';
import { useDeleteCustomerGroup } from '../hooks/use-delete-customer-groups';

export function DeleteCustomerGroupModal({
  slug,
  name,
  isOpen,
  closeModal,
}: {
  slug: string;
  name: string;
  isOpen: boolean;
  closeModal: () => void;
}) {
  const { mutate: deleteGroup } = useDeleteCustomerGroup(name);

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      primaryAction={{
        text: t('buttons:delete'),
        onClick: () => deleteGroup(slug),
        danger: true,
      }}
      secondaryAction={{
        text: t('buttons:cancel'),
        onClick: closeModal,
      }}
    >
      <Modal.Header>
        {t('features:customer_group.components.delete_customer_group_modal.confirm_delete.title')}
      </Modal.Header>
      <Modal.Body>
        <Text variant="secondary" size="md">
          {t('features:customer_group.components.delete_customer_group_modal.confirm_delete.body', {
            name: name,
          })}
        </Text>
      </Modal.Body>
    </Modal>
  );
}
